export default __webpack_public_path__ + "static/media/Narcinthe.15a5eae0.jpg";